import { render, staticRenderFns } from "./RDResultDetail.vue?vue&type=template&id=1bd3ea4f&scoped=true"
import script from "./RDResultDetail.vue?vue&type=script&lang=js"
export * from "./RDResultDetail.vue?vue&type=script&lang=js"
import style0 from "./RDResultDetail.vue?vue&type=style&index=0&id=1bd3ea4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3ea4f",
  null
  
)

export default component.exports